function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{clip-path:url(#SVGID_2_);}\n");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_1_",
  width: 512,
  height: 512
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M488,216c8.8,0,16-7.2,16-16v-80c0-8.8-7.2-16-16-16H301.2C278.4,46.4,222.4,8,160,8C76.2,8,8,76.2,8,160 c0,70.7,48.7,130.2,114.2,147c-1.4,4.1-2.2,8.5-2.2,13v160c0,13.2,10.8,24,24,24h32c13.2,0,24-10.8,24-24V320 c0-4.4-0.8-8.8-2.2-12.9c18-4.6,35-12.5,50.2-23.3V344c0,8.8,7.2,16,16,16h224c8.8,0,16-7.2,16-16v-80c0-8.8-7.2-16-16-16H283.8 c7.1-9.9,12.8-20.6,17.3-32H488z M200,216h47.6c-19,29.5-52,48-87.6,48c-57.3,0-104-46.7-104-104S102.7,56,160,56 c35.5,0,68.6,18.5,87.6,48H200c-8.8,0-16,7.2-16,16v80C184,208.8,191.2,216,200,216 M200,120h96v80h-96V120z M488,200H312v-80h176 L488,200z M176,488h-32c-4.4,0-8-3.6-8-8V360h48v120C184,484.4,180.4,488,176,488 M184,320v24h-48v-24c0-3.4,0.8-6.7,2.1-9.8 c7.2,1,14.4,1.8,21.9,1.8c7.4,0,14.7-0.7,21.9-1.7C183.2,313.3,184,316.6,184,320 M264,264h112v80H264V264z M488,344h-96v-80h96 V344z M263.5,248c-8.4,0.3-15.2,7-15.4,15.5C223.5,284.4,192.4,296,160,296c-75,0-136-61-136-136S85,24,160,24 c53.7,0,102.1,31.7,123.9,80h-17.9C245.4,65,204.4,40,160,40C93.8,40,40,93.8,40,160s53.8,120,120,120c44.4,0,85.4-25,106.1-64 h17.8C278.7,227.6,271.8,238.3,263.5,248"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 456,
  y: 152,
  className: "st0",
  width: 16,
  height: 16
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 424,
  y: 152,
  className: "st0",
  width: 16,
  height: 16
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 392,
  y: 152,
  className: "st0",
  width: 16,
  height: 16
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 360,
  y: 152,
  className: "st0",
  width: 16,
  height: 16
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 328,
  y: 152,
  className: "st0",
  width: 16,
  height: 16
});

var _ref10 = /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "274.3,130.3 232,172.7 221.7,162.3 210.3,173.7 232,195.3 285.7,141.7  "
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M456,392H232c-8.8,0-16,7.2-16,16v80c0,8.8,7.2,16,16,16h224c8.8,0,16-7.2,16-16v-80 C472,399.2,464.8,392,456,392 M232,408h96v80h-96V408z M344,488v-80h112l0,80H344z"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 424,
  y: 440,
  className: "st0",
  width: 16,
  height: 16
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 392,
  y: 440,
  className: "st0",
  width: 16,
  height: 16
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 360,
  y: 440,
  className: "st0",
  width: 16,
  height: 16
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 280,
  y: 296,
  className: "st0",
  width: 16,
  height: 16
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 312,
  y: 296,
  className: "st0",
  width: 16,
  height: 16
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  x: 344,
  y: 296,
  className: "st0",
  width: 16,
  height: 16
});

var _ref18 = /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "306.3,418.3 264,460.7 253.7,450.3 242.3,461.7 264,483.3 317.7,429.7  "
});

var _ref19 = /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "466.3,270.3 424,312.7 413.7,302.3 402.3,313.7 424,335.3 477.7,281.7  "
});

var SvgPvCuidado = function SvgPvCuidado(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, _ref3, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPvCuidado, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pv-cuidado.b78de1a2.svg";
export { ForwardRef as ReactComponent };